import React, { useState, useEffect, useContext } from 'react';
import './InternshipHistory.css';
import { UserContext } from '../UserContext';
import GuestNav from '../Navbars/GuestNav';
import Footer from "../Footer";
import AdminNav from "../Navbars/AdminNav";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from "react-router-dom";

import { 
  faSearch, 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt, 
  faFilePdf, 
  faFolderOpen,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faShieldAlt,
  faLightbulb,
  faProjectDiagram
} from '@fortawesome/free-solid-svg-icons';

const InternshipHistory = () => {
  // const { isGuest, userInfo } = useContext(UserContext);
    const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const uname = userInfo?.uname;
  const [internships, setInternships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [expandedRow, setExpandedRow] = useState(null);
  
  const navigate = useNavigate();
  // const uploadDir = path.join(__dirname, 'public', 'Internship-reg');
  useEffect(() => {
    fetchUserInfo();
    const fetchInternships = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/internshipregistrations`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch internship data');
        }
        
        const data = await response.json();
        setInternships(data);
      } catch (err) {
        console.error('Error fetching internships:', err);
        setError(err.message);
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInternships();
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}`, {
        credentials: "include",
      });
      const data = await response.json();
      setUserInfo(data);
      if (data?.usertype) {
        setUserRole(data.usertype);
      }
    } catch (error) {
      console.log("Error in fetchUserInfo:", error);
    }
  };

  const filteredInternships = internships.filter(internship => {
    const matchesSearch = 
      internship.firstName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      internship.lastName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      internship.email?.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesStatus = 
      filterStatus === 'all' || internship.status === filterStatus;
    
    return matchesSearch && matchesStatus;
  });

  const updateStatus = async (id, newStatus) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/internshipstatus/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: newStatus }),
        credentials: 'include'
      });
      
      const data = await response.json();
      
      if (response.ok) {
        toast.success('Status updated successfully');
        setInternships(internships.map(internship => 
          internship.id === id ? { ...internship, status: newStatus } : internship
        ));
      } else {
        toast.error(data.message || 'Failed to update status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('An error occurred while updating status');
    }
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const toggleExpandRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };

  const getKnowledgeLevel = (level) => {
    switch(level) {
      case 'no_knowledge': return 'No Knowledge';
      case 'beginner': return 'Beginner';
      case 'intermediate': return 'Intermediate';
      case 'advanced': return 'Advanced';
      default: return level;
    }
  };

  const onLogout = () => {
    fetch(`${process.env.REACT_APP_LOCAL_SERVER_API}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

const username = userInfo?.username;

  return (
    <>
      {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}
      <div className="internship-history-container">
        <div className="history-header">
          <h1>Internship <span>Applications</span></h1>
          <p>View and manage all internship applications</p>
        </div>

        <div className="controls-section">
          <div className="search-filter-container">
            <div className="search-box">
              <input
                type="text"
                placeholder="Search by name or email..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <FontAwesomeIcon icon={faSearch} className="search-icon" />
            </div>
            <div className="filter-dropdown">
              <select
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Statuses</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
                <option value="completed">Completed</option>
              </select>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Loading internship applications...</p>
          </div>
        ) : (
          <div className="internship-table-container">
            {filteredInternships.length === 0 ? (
              <div className="no-results">
                <FontAwesomeIcon icon={faFolderOpen} className="folder-icon" />
                <p>No internship applications found</p>
              </div>
            ) : (
              <table className="internship-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Contact</th>
                    <th>Age</th>
                    <th>Skills</th>
                    <th>Applied On</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredInternships.map((internship) => (
                    <React.Fragment key={internship.id}>
                      <tr onClick={() => toggleExpandRow(internship.id)} className="clickable-row">
                        <td>
                          <div className="student-info">
                            {internship.profilePic && (
                              <img 
                                src={`${process.env.REACT_APP_LOCAL_SERVER_API}/${internship.uploadDir}`} 
                                alt="Profile" 
                                className="profile-pic"
                                 onError={(e) => {
                                console.log("Image failed to load:", e);
                                e.target.style.display = 'none';
                                }}
                              />
                            )}
                            <div>
                              <strong>{internship.firstName} {internship.lastName}</strong>
                              <p>{internship.parentName}</p>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div className="contact-info">
                            <p><FontAwesomeIcon icon={faPhone} /> {internship.whatsappNumber}</p>
                            <p><FontAwesomeIcon icon={faEnvelope} /> {internship.email}</p>
                          </div>
                        </td>
                        <td>{internship.age}</td>
                        <td>
                          <div className="skills-tags">
                            {internship.graphicSoftware && internship.graphicSoftware.map((skill, index) => (
                              <span key={index} className="skill-tag">{skill}</span>
                            ))}
                          </div>
                        </td>
                        <td>{formatDate(internship.createdAt)}</td>
                        <td>
                          <span className={`status-badge ${internship.status}`}>
                            {internship.status}
                          </span>
                        </td>
                        <td>
                          <div className="action-buttons">
                            <button 
                              className="view-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                internship?.lastDegree &&window.open(process.env.REACT_APP_LOCAL_SERVER_API+'/'+internship?.lastDegree, '_blank');
                              }}
                            >
                              <FontAwesomeIcon icon={faFilePdf} /> View Docs
                            </button>
                            <div className="status-dropdown">
                              <select
                                value={internship.status}
                                onChange={(e) => {
                                  e.stopPropagation();
                                  updateStatus(internship.id, e.target.value);
                                }}
                              >
                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                                <option value="completed">Completed</option>
                              </select>
                            </div>
                          </div>
                        </td>
                      </tr>
                      {expandedRow === internship.id && (
                        <tr className="expanded-row">
                          <td colSpan="7">
                            <div className="additional-details">
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faMapMarkerAlt} /> Address</h4>
                                <p>{internship.address}, {internship.city}, {internship.country}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faFileWord} /> MS Word Knowledge</h4>
                                <p>{getKnowledgeLevel(internship.wordKnowledge)}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faFileExcel} /> Excel Knowledge</h4>
                                <p>{getKnowledgeLevel(internship.excelKnowledge)}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faFilePowerpoint} /> PowerPoint Knowledge</h4>
                                <p>{getKnowledgeLevel(internship.pptKnowledge)}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faLightbulb} /> Problem Solving</h4>
                                <p>{internship.problemSolving?.charAt(0).toUpperCase() + internship.problemSolving?.slice(1)}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faProjectDiagram} /> Project Experience</h4>
                                <p>{internship.projectExperience?.charAt(0).toUpperCase() + internship.projectExperience?.slice(1)}</p>
                              </div>
                              <div className="detail-section">
                                <h4><FontAwesomeIcon icon={faShieldAlt} /> Internet Safety</h4>
                                <p>{internship.internetSafety?.charAt(0).toUpperCase() + internship.internetSafety?.slice(1)}</p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default InternshipHistory;